import { SVGProps, Ref, forwardRef } from 'react';

export const ImageFilledSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <g>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8 .5C1.438.5.5 1.438.5 8c0 1.229.033 2.26.13 3.125l4.935-4.023 3.645 2.86 2.436-1.915 3.725 3.077c.096-.865.129-1.896.129-3.124 0-6.562-.937-7.5-7.5-7.5m1.343 3.633c.204-.245.526-.4.988-.4s.783.155.988.4c.202.243.278.56.278.866 0 .307-.076.624-.278.866-.205.246-.527.4-.988.4-.462 0-.784-.154-.988-.4-.202-.242-.279-.56-.279-.866s.077-.623.279-.866"
                    fill="currentColor"
                />
                <path
                    d="M8 15.5c-4.488 0-6.345-.438-7.07-2.814l4.652-3.791 3.629 2.847 2.413-1.897 3.445 2.845C14.343 15.062 12.485 15.5 8 15.5"
                    fill="currentColor"
                />
            </g>
        </g>
    </svg>
));
ImageFilledSize16Glyph.displayName = 'ImageFilledSize16Glyph';
